import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { CellButton, CellButtons } from '../CellButton';
import { PerformActionButton } from '../PerformActionButton';
import { View } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';

import { VehiclePropertyLoadable } from '../../../Vehicles/components/VehiclePropertyLoadable';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import { WithVehicle } from '../../../Vehicles/components/WithVehicle';
import { HBox, VBox } from '../../../../components/Box';
import { Row } from '../../../../components/List';
import { Cell } from '../Cell';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import { KanbanVehicleRemarks } from '../../components/KanbanVehicleRemarks';
import { BaseCellComp } from '../BaseCellComp';
import { performAction } from '../../actions';
import { setVehicleProperty } from '../../../Vehicles/actions';
import { selectVehicle } from '../../../Vehicles/selectors';
import { selectUserId, selectWork, selectWorks } from '../../../Api/selectors';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../../../Vehicles/constants';
import { getRemarkType } from '../helpers/getRemarkType';
import { COLOR_PRIMARY_1 } from '../../../../vars';
import styles from './Hooi_Default.module.css';
import { DoubleCheck } from '../../../../containers/App/Components/DoubleCheck/DoubleCheck';
import { VehicleEditableField } from '../../../Vehicles/components/VehicleEditableField';
import { Label } from '../../../Vehicles/components/VehicleCounterLabel';
import { VehicleProductTasksSection } from '../../../Vehicles/components/VehicleProductTasksSection';
import { VehicleLocationCard } from '../../../Vehicles/components/VehicleLocationCard';

dayjs.extend(customParseFormat);

const ranges = {
  MediumSeaGreen: [2, 4],
  DarkOrange: [5, 29],
  Crimson: [30, Infinity],
};
const TASK_REMARK_TYPE = 'HOOI_NEW_task_order_key_program_dealer';
const Container = styled.div`
  .modal-inner {
  }

  .manco-list > div {
  }
`;

let todaydate = new Date().toISOString();

const STATE = {
  approve: false,
  regplate_code: '',
};

/* eslint-disable react/prefer-stateless-function */
class HOOI_new_key_wait_tdnComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {
    const { vehicle, setProperty } = this.props;
  if (!vehicle || !prevProps.vehicle) return;

    if (
      vehicle?.TDN_ontvangen_en_pdf_gesfuurd_naar_dealer === '1' &&
      prevProps.vehicle?.TDN_ontvangen_en_pdf_gesfuurd_naar_dealer !== '1' &&
      vehicle?.TDN_present !== '1'
    ) {
      setProperty('TDN_present', '1');
    }

    const watchProps = [
      'order_key',
      'order_key_dealer',
      'order_key_dealer_status',
      'key_received_from_dealer',
      'transport_order_to_dealer',
      'key_programmed_dealer_ready',
      'is_the_car_drivable',
      'transport_order_from_dealer_to_steenwijk',
      'transport_order_from_dealer_to_staphorst',
      'result_coordinated_with_client',
      'TDN_message_to_client',
      'TDN_present',
      'TDN_ontvangen_en_pdf_gesfuurd_naar_dealer',
      'HOOI_NEW_loaded_for_transport_and_change_location_keyprogram',
      'HOOI_NEW_TDN_available',
      'HOOI_NEW_TDN_present',
      'HOOI_NEW_mail_TDN'
    ];

 const propChanged = watchProps.some(
    prop => vehicle?.[prop] !== prevProps.vehicle?.[prop]
  );
    if (propChanged) {
      const today = new Date().toISOString().split('T')[0];
      if (vehicle?.HOOI_NEW_keys_waiting !== today) {
        setProperty('HOOI_NEW_keys_waiting', today);
      }
    }
  }
  dateDifference(HOOI_NEW_keys_waiting) {
    const createdDate = HOOI_NEW_keys_waiting || this.propertyValue('HOOI_NEW_keys_waiting');
    if (!createdDate) return 0;

    const now = dayjs();
    const created = dayjs(createdDate, 'YYYY-MM-DD'); // <-- correct parse format

    if (!created.isValid()) return 0;

    const diff = now.diff(created, 'day');
    return diff;
  }

  get vehicle() {
    return this.props.cell.vehicle;
  }
  get doubleCheckProps() {
    return [
      'HOOI_NEW_order_key_program_dealer_ready',
      'HOOI_NEW_order_key_transport_to_steenwijk',
      'HOOI_NEW_order_key_change_location',
    ];
  }

  reset() {
    this.setState({ ...STATE });
  }

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.vehicle.id, this.state.regplate_code);
  }

  propertyValue(name) {
    return this.props.vehicle?.[name] ?? null;
  }

  disableConfirmation() {
    let disable = false;

    this.doubleCheckProps.forEach(prop => {
      if (this.props.vehicle?.[prop] !== '0') {
        disable = true;
      }
    });

    return disable;
  }

  renderApprove() {
    if (!this.state.approve) return null;

    return (
      <ModalComponent onClose={this.reset.bind(this)} title={this.props.column.label}>
        <WithVehicle loader vehicle_id={this.vehicle.id}>
          <div className="mb-2">
            <VehicleHeader vehicle={this.vehicle} hooikammer kanbanCell />
          </div>

          <Container>
            <VBox className="manco-list" key="manco">
              <Row>
                <Cell>
                  {['TDN_present'].map(name => (
                    <DoubleCheck key={name} name={name} vehicle={this.props.vehicle} yesNo />
                  ))}
                </Cell>
              </Row>
              {this.propertyValue('TDN_present') == '1' && (
                <>
                  <Row>
                    <Cell>
                      {['order_key'].map(name => (
                        <DoubleCheck key={name} name={name} vehicle={this.props.vehicle} />
                      ))}
                    </Cell>
                  </Row>
                  {this.propertyValue('order_key') === '1' && (
                    <Row>
                      <Cell>
                        <VehicleEditableField
                          name={'order_key_dealer'}
                          inputType={'textarea'}
                          vehicle={this.props.vehicle}
                        />
                      </Cell>
                    </Row>
                  )}
                  {/* {this.propertyValue('order_key_dealer') && (
                    <Row>
                      <Cell>
                        {['order_key_dealer_status'].map(name => (
                          <DoubleCheck
                            key={name}
                            name={name}
                            vehicle={this.props.vehicle}
                            customYes={'Besteld'}
                            customNo={'Niet besteld'}
                          />
                        ))}
                      </Cell>
                    </Row>
                  )} */}

                  {this.propertyValue('order_key') === '1' && (
                    <Row>
                      <Cell>
                        {['key_received_from_dealer'].map(name => (
                          <DoubleCheck key={name} name={name} vehicle={this.props.vehicle} />
                        ))}
                      </Cell>
                    </Row>
                  )}
                  {this.propertyValue('key_received_from_dealer') === '1' && (
                    <Row>
                      <Cell>
                        {['transport_order_to_dealer'].map(name => (
                          <DoubleCheck key={name} name={name} vehicle={this.props.vehicle} />
                        ))}
                      </Cell>
                    </Row>
                  )}

                  {this.propertyValue('transport_order_to_dealer') === '1' && (
                    <>
                   
                       
                        <VehicleProductTasksSection vehicleId={this.vehicle?.id} fromKanban />
                        
                 
                      <Row>
                        <Cell>
                          <DoubleCheck
                            key={'HOOI_NEW_loaded_for_transport_and_change_location_keyprogram'}
                            name={'HOOI_NEW_loaded_for_transport_and_change_location_keyprogram'}
                            vehicle={this.props.vehicle}
                          />
                        </Cell>
                      </Row>

                      {this.propertyValue('HOOI_NEW_loaded_for_transport_and_change_location_keyprogram') === '1' && (

                      <VehicleLocationCard vehicle={this.vehicle} kanbanActionPage />
                      )}
                      <Row></Row>
                      <Row>
                        <Cell>
                          {['key_programmed_dealer_ready'].map(name => (
                            <DoubleCheck key={name} name={name} vehicle={this.props.vehicle} />
                          ))}
                        </Cell>
                      </Row>
                    </>
                  )}

                  {this.propertyValue('key_programmed_dealer_ready') === '1' && (
                    <Row>
                      <Cell>
                        {['is_the_car_drivable'].map(name => (
                          <DoubleCheck key={name} name={name} vehicle={this.props.vehicle} />
                        ))}
                      </Cell>
                    </Row>
                  )}
                  {this.propertyValue('is_the_car_drivable') === '1' && (
                    <>
                      <Row>
                        <Cell>
                          {['transport_order_from_dealer_to_steenwijk'].map(name => (
                            <DoubleCheck key={name} name={name} vehicle={this.props.vehicle} />
                          ))}
                        </Cell>
                      </Row>
                      {this.propertyValue('transport_order_from_dealer_to_steenwijk') === '1' && ( <VehicleProductTasksSection vehicleId={this.vehicle?.id} fromKanban />)}

                    </>
                  )}
                  {this.propertyValue('is_the_car_drivable') === '0' && (
                    <>
                      <Row>
                        <Cell>
                          {['transport_order_from_dealer_to_staphorst'].map(name => (
                            <DoubleCheck key={name} name={name} vehicle={this.props.vehicle} />
                          ))}
                        </Cell>
                      </Row>
                      {this.propertyValue('transport_order_from_dealer_to_staphorst') === '1' && ( <VehicleProductTasksSection vehicleId={this.vehicle?.id} fromKanban />)}
                      <Row>
                        <Cell>
                          {['result_coordinated_with_client'].map(name => (
                            <DoubleCheck key={name} name={name} vehicle={this.props.vehicle} />
                          ))}
                        </Cell>
                      </Row>
                    </>
                  )}
                </>
              )}
              {this.propertyValue('TDN_present') == '0' && (
                <>
                  <Row>
                    <Cell>
                      {['TDN_available'].map(name => (
                        <DoubleCheck key={name} name={name} vehicle={this.props.vehicle} />
                      ))}
                    </Cell>
                  </Row>
                  {this.propertyValue('TDN_available') == '1' && (
                    <>
                      <Row>
                        <Cell>
                          <VehicleEditableField
                            name={'reason_key_not_orderable'}
                            inputType={'textarea'}
                            vehicle={this.props.vehicle}
                          />
                        </Cell>
                      </Row>
                    </>
                  )}
                  {this.propertyValue('TDN_available') == '0' && (
                    <>
                      <Row>
                        <Cell>
                          <DoubleCheck name={'TDN_message_to_client'} vehicle={this.props.vehicle} />
                        </Cell>
                      </Row>
                      {/* {this.propertyValue('TDN_message_to_client') === '1' && (
                        <Row>
                          <Cell>
                            <DoubleCheck
                              name={'TDN_requested'}
                              vehicle={this.props.vehicle}
                              customYes={'To be done'}
                              customNo={'Waiting for follow up'}
                            />
                          </Cell>
                        </Row>
                      )} */}
                      {this.propertyValue('TDN_message_to_client') === '1' && (
                        <Row>
                          <Cell>
                            <DoubleCheck name={'TDN_ontvangen_en_pdf_gesfuurd_naar_dealer'} vehicle={this.props.vehicle} />
                          </Cell>
                        </Row>
                      )}
                      <Row>
                        <Cell>
                          <VehicleEditableField
                            name={'TDN_client_feedback'}
                            inputType={'textarea'}
                            vehicle={this.props.vehicle}
                          />
                        </Cell>
                      </Row>
                    </>
                  )}
                  {this.propertyValue('HOOI_NEW_TDN_available') == '0' && (
                    <>
                      <Row>
                        <Cell>
                          {['HOOI_NEW_mail_TDN'].map(name => (
                            <DoubleCheck key={name} name={name} vehicle={this.props.vehicle} />
                          ))}
                        </Cell>
                      </Row>
                    </>
                  )}
                </>
              )}
              {this.propertyValue('HOOI_NEW_TDN_present') == '0' && (
                <>
                  <Row>
                    <Cell>
                      {['HOOI_NEW_TDN_available'].map(name => (
                        <DoubleCheck key={name} name={name} vehicle={this.props.vehicle} />
                      ))}
                    </Cell>
                  </Row>
                  {this.propertyValue('HOOI_NEW_TDN_available') == '1' && (
                    <Row>
                      <Cell>
                        <VehicleEditableField
                          name={'reason_key_not_orderable'}
                          inputType={'textarea'}
                          vehicle={this.props.vehicle}
                        />
                      </Cell>
                    </Row>
                  )}
                </>
              )}
              <HBox className="mt-3">
                {this.props.workRemarks ? (
                  <Loader small />
                ) : (
                  <KanbanVehicleRemarks
                    key={'modal'}
                    fullWidth={true}
                    taskName={TASK_REMARK_TYPE}
                    kanbanBoardLabel={this.props.board?.label}
                    vehicleId={this.vehicle.id}
                    loggedUserId={this.props.loggedInUserId}
                  />
                )}
              </HBox>
            </VBox>
          </Container>
        </WithVehicle>
        <div className="d-flex gap-2 mt-3">
          <PerformActionButton
            className={styles.confirmButton}
            action={this.props.action}
            target={this.vehicle}
            onChange={this.reset.bind(this)}
          />

          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }

  renderIcon(vehicle) {
    if (
      (vehicle.TDN_message_to_client == '1' && vehicle.TDN_present == '0') ||
      (vehicle.transport_order_to_dealer === '1' && vehicle.key_programmed_dealer_ready && !vehicle.transport_order_from_dealer_to_steenwijk) ||
      (vehicle.order_key === '1' && !vehicle.key_received_from_dealer) ||
      (vehicle.HOOI_NEW_loaded_for_transport_and_change_location_keyprogram === '1' && !vehicle.key_programmed_dealer_ready)
    ) {
      return (
        <img
          src="https://vindat.indewal.nl/storage/documents/ac98742c-10cb-41c6-980f-952787ea0dbb.png"
          alt="Kleine afbeelding"
          style={{ width: '25px', height: '25px', margin: '5px' }}
        />
      );
    }

    return;
  }

  render() {
    const vehicle = this.vehicle;

    const Date = vehicle.HOOI_NEW_keys_waiting || dayjs();;

    const days = this.dateDifference(Date);


    // if (!this.props.vehicle) return <Loader />;
    let message = '';

    if (vehicle.TDN_message_to_client === '1' && vehicle.TDN_present === '0') {
      message = 'Wacht op: TDN';
    } else if (vehicle.transport_order_to_dealer === '1' && vehicle.key_programmed_dealer_ready && !vehicle.transport_order_from_dealer_to_steenwijk) {
      message = 'Wacht op: Transport';
    } else if (vehicle.order_key === '1' && !vehicle.key_received_from_dealer) {
      message = 'Sleutel besteld';
    }
    else if (vehicle.HOOI_NEW_loaded_for_transport_and_change_location_keyprogram === '1' && !vehicle.key_programmed_dealer_ready) {
      message = 'Wacht op: Dealer';
    }
    return (
      <Cell>
        <Container>
          <VehicleHeader vehicle={vehicle} kanbanCell />
          <Label count={days} ranges={ranges}>
                      {days}
                    </Label>{message}
          <CellButtons>
            {this.renderIcon(vehicle)}
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <>
                {this.props.workRemarks ? (
                  <Loader small />
                ) : (
                  <KanbanVehicleRemarks
                    readOnly
                    taskName={TASK_REMARK_TYPE}
                    kanbanBoardLabel={this.props.board?.label}
                    vehicleId={this.vehicle.id}
                    loggedUserId={this.props.loggedInUserId}
                  />
                )}
                <CellButton
                  onClick={this.setStateFn({ approve: !this.state.approve, regplate_code: vehicle.regplate_code || '' })}
                >
                  <View />
                </CellButton>
              </>
            )}
          </CellButtons>
        </Container>
        {this.renderApprove()}
      </Cell>
    );
  }
}

HOOI_new_key_wait_tdnComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([`${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle?.id}`]),
    vehicle: selectVehicle(ownProps.cell.vehicle.id),
    loggedInUserId: selectUserId(),
    workRemarks: selectWork(`${REQUEST_VEHICLE_PROPERTY_UPDATE}-${getRemarkType(TASK_REMARK_TYPE)}`),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    confirm(vehicle_id, regplate_code) {
      dispatch(performAction(ownProps.action.id, vehicle_id, { regplate_code }));
    },
    setProperty(name, value) {
      dispatch(setVehicleProperty(ownProps.cell.vehicle.id, name, value));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const HOOI_new_key_wait_tdn = compose(withConnect, withRouter)(HOOI_new_key_wait_tdnComp);
